// extracted by mini-css-extract-plugin
export default {"container":"CardList_container__ktp04"};